<section id="select-action">
  <ul class="action-list">
    <li class="action-list-item">
      <form [formGroup]="actionForm">
        <aside class="initial-action"
               [ngClass]="actionTypeControl.value === dataRulesService.actionOpName(actionOps.REPLACE) && sourceTypeControl.value === 'BOOLEAN' ? 'grid-3-boolean' : ''"
               [ngSwitch]="actionTypeControl.value">
          <app-paired-autocomplete
            #fieldName [selectedFieldControl]="fieldToChangeControl"
            [secondaryEntityControl]="fieldToChangeDescriptorControl"
            [primaryEntity]="primaryEntity"
            [componentId]="'action-fieldValue'"
            [entitiesOptions]="entitiesOptions"
            [inputRequired]="true"
            [dataSourceType]="dataSourceType"
            [overlayPositioningConfig]="overlayPositioningConfig"
            (inputCleared)="fieldToChangeCleared()"
          ></app-paired-autocomplete>
          <mat-select #actionTypeSelect class="full-width" formControlName="type" [placeholder]="actionTypePlaceholder"
                    [matTooltip]="actionTypeSelect.triggerValue" matTooltipShowDelay="500">
            <mat-option *ngFor="let op of actionOperators"
                        value="{{dataRulesService.actionOpName(op)}}">{{op.toString()}}</mat-option>
          </mat-select>
        </aside>
        <app-action-address
                *ngIf="fieldToChangeTypeControl.value === 'ADDRESS' && (
          actionTypeControl.value === dataRulesService.actionOpName(actionOps.APPEND)
          || actionTypeControl.value === dataRulesService.actionOpName(actionOps.NULLIFY)
          || actionTypeControl.value === dataRulesService.actionOpName(actionOps.PREPEND)
          || actionTypeControl.value === dataRulesService.actionOpName(actionOps.REPLACE)
          || actionTypeControl.value === dataRulesService.actionOpName(actionOps.SUBSTITUTE)
          || actionTypeControl.value === dataRulesService.actionOpName(actionOps.FORMAT)
          ); else notAddress"
                [actionData]="actionData"
                [formGroup]="actionForm"
                [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                [primaryEntity]="primaryEntity">
        </app-action-address>
        <ng-template #notAddress>
          <app-action-append *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.APPEND)"
                             [actionData]="actionData"
                             [formGroup]="actionForm"
                             [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                             [primaryEntity]="primaryEntity"
          >
          </app-action-append>
          <app-action-prepend *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.PREPEND)"
                              [actionData]="actionData"
                              [formGroup]="actionForm"
                              [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                              [primaryEntity]="primaryEntity"
          >
          </app-action-prepend>
          <app-action-substitute *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.SUBSTITUTE)"
                                 [actionData]="actionData"
                                 [formGroup]="actionForm"
                                 [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                                 [primaryEntity]="primaryEntity"
          >
          </app-action-substitute>
          <app-action-math *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.MATHS)"
                           [actionData]="actionData"
                           [formGroup]="actionForm"
                           [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                           [primaryEntity]="primaryEntity"
          >
          </app-action-math>
          <app-action-replace *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.REPLACE)
                            && fieldToChangeTypeControl.value !== 'ADDRESS'"
                              [actionData]="actionData"
                              [formGroup]="actionForm"
                              [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                              [primaryEntity]="primaryEntity"
          >
          </app-action-replace>
          <app-action-replace-relative
            *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.REPLACE_RELATIVE)"
            [actionData]="actionData"
            [formGroup]="actionForm"
            [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
            [primaryEntity]="primaryEntity"
          >
          </app-action-replace-relative>
          <app-action-stringformat *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.FORMAT)"
                                   [actionData]="actionData"
                                   [formGroup]="actionForm"
                                   [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                                   [primaryEntity]="primaryEntity"
          >
          </app-action-stringformat>
          <app-action-copymoveswap *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.COPY)
                                     || actionTypeControl.value === dataRulesService.actionOpName(actionOps.MOVE)
                                     || actionTypeControl.value === dataRulesService.actionOpName(actionOps.SWAP)"
                                   [actionData]="actionData"
                                   [formGroup]="actionForm"
                                   [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                                   [primaryEntity]="primaryEntity"
          >
          </app-action-copymoveswap>
          <app-action-count *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.COUNT)"
                                   [actionData]="actionData"
                                   [formGroup]="actionForm"
                                   [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                                   [primaryEntity]="primaryEntity"
          >
          </app-action-count>
          <app-action-change *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.CHANGE)"
                             [actionData]="actionData"
                             [formGroup]="actionForm"
                             [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                             [primaryEntity]="primaryEntity"
          >
          </app-action-change>
          <app-action-addremove *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.ADD)
                                  || actionTypeControl.value === dataRulesService.actionOpName(actionOps.REMOVE)"
                                [actionData]="actionData"
                                [formGroup]="actionForm"
                                [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                                [primaryEntity]="primaryEntity"
          >
          </app-action-addremove>
          <app-action-append-entries *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.APPEND_ENTRY)"
                                     [actionData]="actionData"
                                     [formGroup]="actionForm"
                                     [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                                     [primaryEntity]="primaryEntity"
          >
          </app-action-append-entries>
          <app-action-concatenate-entries *ngIf="actionTypeControl.value === dataRulesService.actionOpName(actionOps.CONCATENATE)"
                           [actionData]="actionData"
                           [formGroup]="actionForm"
                           [fieldToChangeDescriptorControl]="fieldToChangeDescriptorControl"
                           [primaryEntity]="primaryEntity"
          >
          </app-action-concatenate-entries>
          <app-action-message-description *ngIf="actionTypeControl.value
                           && primaryEntity.endsWith('FileAttachment')
                           && destinationDescriptorControl.value === null
                           && fieldToChangeControl.value === 'isDeleted'"
                           [primaryEntity]="primaryEntity"
                           [messageStyle]="'warning'"
                           [messageIcon]="'error_outline'"
          >
          </app-action-message-description>
        </ng-template>
      </form>
    </li>
  </ul>
<!--    {{actionForm.value | json}} | valid={{actionForm.valid}}, dirty={{actionForm.dirty}}-->
<!--    <br/>-->
<!--    {{invalidControls}}-->
</section>
